<template>
    <div class="modal fade" id="forceAlertPopup" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" >

        <div class="modal-dialog modal-sm">
        <div class="modal-content" v-if="lastAlert && lastAlert.data && lastAlert.data.alert">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel"> განგაში </h5>
<!--            <button type="button" class="btn-close" id="close-modal" data-bs-dismiss="modal" aria-label="Close"></button>-->
            <button type="button" class="btn-close" id="close-modal" @click="closeModal"></button>
          </div>
          <div class="modal-body">
            <div class="d-flex flex-column justify-content-center align-items-start force-alert-list" >
              <div><span class="name">განგაში:</span> {{ lastAlert.data.alert.alert.name }}</div>
              <div><span class="name">საწყობის:</span> {{ lastAlert.data.alert.controller.warehouse.name }}</div>
              <div><span class="name">სენსორი:</span> {{ lastAlert.data.alert.sensor ? lastAlert.data.alert.sensor.name : 'ყველა' }} </div>
              <div><span class="name">ოთახი:</span> {{ getAlertRoom(lastAlert)}} </div>
              <div><span class="name">ლიმიტი:</span> {{ lastAlert.data.alert.value2 }}</div>
              <div><span class="name">დაფიქსირდა:</span> {{lastAlert.data.alert.value3}} </div>
              <div><span class="name">თარიღი:</span> {{ getDate(lastAlert.data.alert.datestamp) }}</div>
            </div>
          </div>
          <div class="modal-footer d-flex justify-content-center">
            <button  class="btn btn-brand" @click.prevent="makeReadedAlert(lastAlert.data.alert)" >წაკითხულად მონიშვნა</button>
            <button @click="goToAlert(lastAlert.data.alert.id)"  class="btn btn-primary"> ნახვა </button>
          </div>
        </div>
      </div>

    </div>


</template>

<script>
import moment from "moment";

export default {
  name:'ForceAlertPopup',
  props:['theAlert'],
  components:{
  },
  computed:{
    lastAlert(){
      return this.$parent.lastAlert
    }
  },
  methods:{
    getAlertRoom(alert){
      if (alert.data.alert.alert.value4 === "-1"){
        return alert.data.alert.extraRoom.room.name
      }else{
        return alert.data.alert.sensor === null || alert.data.alert.sensor.room_to_sensor === null ? '-- --' : alert.data.alert.sensor.room_to_sensor.room.name
      }
    },
    goToAlert(alertId){
      this.$parent.lastAlertModal.hide()
      this.$store.state.alert.lastAlert = null
      // this.$parent.showingAlert = false
      this.$router.push({ path: '/received-alerts', query: { alertId: alertId } })
    },
    closeModal(){
      if (this.$parent.lastAlertModal){
        this.$parent.lastAlertModal.hide();
        this.$store.state.alert.lastAlert = null
        // if we need repeatedly show alert
        // this.$parent.showingAlert = false
      }
    },
    getDate(date){
      return moment(date).format('D/M/YY HH:mm:ss')
    },
    getAlertDescription(alert){
      let tempType = alert.value1 === "1" ? "ასცდა " : "ჩამოსცდა "
      return `${tempType} ლიმიტს : ${alert.value2} დაფიქსირდა:  ${alert.value3}`
    },
    makeReadedAlert(alert){
      let s = this.$parent.lastAlertModal
      this.$store.dispatch('alert/makeAlertReaded', alert.id).then(
          () =>{
            this.$store.state.alert.showingLastAlertIcon = false
            this.$store.state.alert.lastAlert = null
            //if we need repeatedly show alert
            // this.$parent.showingAlert = false
            s.hide()
          }
      )

    },
  },
  data(){
    return {
    }
  }

}
</script>

<style scoped>

.modal{
  z-index: 99999;
}

.modal-title{
  font-size: 18px;
  font-family: "TBCDinMtavruli-Bold";
}

.popup-form{
  text-align: left;
}

.force-alert-list{
  font-family: "TBCDinNusxuri-Medium";
  color: var(--second-titles);
}
span.name{
  color: var(--input-color);
  font-weight:bold;
}
.btn-primary, .btn-primary:focus, .btn-primary:hover{
  background-color: #F47B7A;
}
.modal-dialog{
  margin-top: 15%;
}

</style>